/**
 * LeaguePills - [Phase 2a.2-B §4.1]
 *
 * Renders Mode (LIVE/MOCK) + Phase (DRAFT/SEASON/COMPLETE) pills for a
 * league tile. Phase deduced from `league.status`; Mode deduced from
 * `league.settings.league_type`.
 */
const PHASE_DRAFT_STATUSES   = new Set(["SETUP", "LOBBY", "DRAFTING", "PAUSED"]);
const PHASE_SEASON_STATUSES  = new Set(["DRAFT_COMPLETE", "SEASON_ACTIVE", "PLAYOFFS"]);
const PHASE_COMPLETE_STATUSES = new Set(["SEASON_COMPLETE", "ARCHIVED", "COMPLETE"]);

export default function LeaguePills({ league }) {
  const leagueType = league?.settings?.league_type || "LIVE_DRAFT_LIVE_SEASON";
  const isMock = leagueType.includes("MOCK");
  const status = league?.status || "SETUP";

  let phaseLabel, phaseClasses;
  if (PHASE_DRAFT_STATUSES.has(status)) {
    phaseLabel = "DRAFT";
    phaseClasses = "bg-[#FF6B00]/10 text-[#FF6B00] border-[#FF6B00]/30";
  } else if (PHASE_SEASON_STATUSES.has(status)) {
    phaseLabel = "SEASON";
    phaseClasses = "bg-[#00C853]/10 text-[#00C853] border-[#00C853]/30";
  } else if (PHASE_COMPLETE_STATUSES.has(status)) {
    phaseLabel = "COMPLETE";
    phaseClasses = "bg-white/[0.06] text-[rgba(255,255,255,0.50)] border-white/[0.10]";
  } else {
    phaseLabel = status;
    phaseClasses = "bg-white/[0.04] text-[rgba(255,255,255,0.40)] border-white/[0.06]";
  }

  const modeLabel = isMock ? "MOCK" : "LIVE";
  const modeClasses = isMock
    ? "bg-white/[0.06] text-[rgba(255,255,255,0.65)] border-white/[0.10]"
    : "bg-[#00C853]/10 text-[#00C853] border-[#00C853]/30";

  const tooltip = `This is a ${isMock ? "mock" : "live"} league currently in the ${phaseLabel.toLowerCase()} phase.`;

  return (
    <div className="flex items-center gap-1" title={tooltip} data-testid={`league-pills-${league?.id || ""}`}>
      <span className={`${modeClasses} border font-display font-bold text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full`}
            data-testid={`league-pill-mode-${league?.id || ""}`}>
        {modeLabel}
      </span>
      <span className={`${phaseClasses} border font-display font-bold text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full`}
            data-testid={`league-pill-phase-${league?.id || ""}`}>
        {phaseLabel}
      </span>
    </div>
  );
}
